import React from 'react'
import Select, {components} from 'react-select'
import {applyFilter} from '../../../redux/actions/pageGlobal'
import {useDispatch, useSelector} from 'react-redux'

const TARGETING_TYPE_MAP = {
  'auto': 'Auto',
  'manual': 'Manual',
}

const CAMPAIGN_TYPE_MAP = {
  'sp': 'Sponsored Products',
  'sb': 'Sponsored Brands',
  'sd': 'Sponsored Display',
}

const Option = (props) => {
  const { innerRef, innerProps, getStyles, data } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={getStyles('option', props)}
      className="campaign-option"
    >
      <div className="campaign-info">
        <span className="campaign-name" title={data.campaign}>{data.campaign}</span>
        <div className="campaign-detail">
          <span>
            {`${TARGETING_TYPE_MAP[data.targeting_type]}  ${CAMPAIGN_TYPE_MAP[data.campaignType]}`}
          </span>
        </div>
      </div>
    </div>
  )
}

// https://github.com/JedWatson/react-select/issues/4170#issuecomment-682465724
const ValueContainer = (props) => {
  const { options, children, getValue } = props
  const selectCount = getValue().length
  let contents = children
  if (selectCount > 0) {
    if (selectCount === options.length) {
      contents = (
        <>
          All Campaigns selected
          { children[1] }
        </>
      )
    } else if (selectCount >= 10) {
      contents = (
        <>
          { selectCount } Campaigns selected
          { children[1] }
        </>
      )
    }
  }
  return (
    <components.ValueContainer {...props}>
      { contents }
    </components.ValueContainer>
  )
}

const MultiValueLabel = (props) => {
  const { data } = props
  return (
    <components.MultiValueLabel {...props}>
      <span className="placeholder-image" title={data.campaign}>
            {data.campaign}
      </span>

    </components.MultiValueLabel>
  )
}


const CampaignSelectFilter = ({
  campaigns,
  selectedCampaigns,
  wrapperStyle = {
    maxWidth: '300px',
    minWidth: '200px',
  },
  isLoading,
  onChange,
}) => {
  const dispatch = useDispatch()
  const filterValues = useSelector(state => state.pageGlobal.filterValues)

  const handleChange = (selected) => {
    // Pass the full selected objects array to the parent
    onChange(selected || [])

    dispatch(
      applyFilter(
        'campaignDetailBidKeyword',
        {
          ...(filterValues['campaignDetailBidKeyword'] || {}),
          campaignIds: selected.map(campaign => campaign.id || campaign.campaign_id),
        }
      )
    )
  }

  // Convert selectedCampaigns (array of IDs) to actual campaign objects for the value prop
  const selectedValues = campaigns.filter(campaign =>
    selectedCampaigns && selectedCampaigns.some(selectedId =>
      (campaign.id || campaign.campaign_id) === selectedId
    )
  )

  return (
    <div className="campaign-select-filter-wrapper" style={wrapperStyle}>
      <Select
        options={campaigns}
        isSearchable
        isClearable
        isMulti={true}
        value={selectedValues}
        closeMenuOnSelect={false}
        allowCreateWhileLoading={false}
        hideSelectedOptions={false}
        disabled={isLoading}
        isLoading={isLoading}
        getOptionLabel={(option) => option.campaign || option.name}
        getOptionValue={(option) => option.id || option.campaign_id}
        components={{
          Option,
          ValueContainer,
          MultiValueLabel,
        }}
        pageSize={20}
        placeholder="Select campaigns..."
        onChange={handleChange}
      />
    </div>
  )
}

export default CampaignSelectFilter
